import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Tamadoge_Logo from "../assets/images/Tamadoge_Logo.png";
import { Button, HeaderLinks, LinkButton, options } from "../const";
import BurgerMenu from "../assets/images/hamburger.svg";
import BurgerCloseMenu from "../assets/images/hamburger-close.svg";
import Down from "../assets/images/down.svg";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const Nav = styled.div`
  height: 70px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 38px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.1);
 
  @media screen and (max-width: 768px) {
    height: 60px;
  }
  .logo {
    @media screen and (max-width: 1200px) {
      height: 30px !important;
    }
  } 
  @media screen and (min-width: 1024px) and (max-width: 1290px) {
    padding: 0 5px;
  }
`;

const BurgerMenuContainer = styled.div`
  display: none;
  @media screen and (max-width: 1024px) {
    display: flex;
    cursor: pointer;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

const Link = styled.li`
  margin: 0 10px;
  list-style-type: none;
  cursor: pointer;
  font-weight: 500;
  a{
    color:black;
    text-decoration: none;
  }
  &:hover .list{
   display: flex;
  }
  @media screen and (max-width: 1150px) {
    margin: 0 8px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1300px) {
    margin: 0 6px;
    font-size: 13px;
  }
`;

const FeedBack = styled.button`
    background: #fed743;
    border: 3px solid #333;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;
    padding: 0 10px;
    height: 46px; 
    cursor:pointer ;
  
  @media screen and (min-width: 1024px) and (max-width: 1300px) {
    font-size: 13px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;
const SelectInputWrapper = styled.div`
  position: relative;
  width: 140px;
  margin: 5px;
  height: 46px;
  @media screen and (min-width: 1024px) and (max-width: 1220px) {
    width: 120px;
  }
`;
const SelectContainer = styled.div`
  border: 3px solid #333333;
  font-weight: 900;
  cursor: pointer;
  user-select: none;
  background-color: white;
  height: 40px;
  display: flex;
  align-items: center;
  p {
    font-size: 15px;
    padding: 0;
    margin: 0 10px;
  }
  img {
    position: absolute;
    height: 10px;
    top: 17px;
    right: 12px;
  }
`;
const OptionsContainer = styled.div`
  position: absolute;
  background-color: white;
  left: 0px;
  top: 50px;
  width: 100%;
  max-height: 200px;
  box-shadow: 0 20px 30px #00000030;
  z-index: 2;
  &.scroll {
    overflow-y: scroll;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #222222;
    border-radius: 10px;
    &:hover {
      background: #555555;
    }
  }
  cursor: pointer;
  .option {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    border-bottom: 1px solid #8bd1ea90;
    height: 40px;
    span {
      font-size: 14px;
      padding: 3px 0;
      font-weight: 500;
    }
    &.active,
    &:hover {
      background-color: #8bd1ea70;
    }
  }
`;
const MobileViewContainer = styled.div`
  display: none;
  @media screen and (max-width: 1024px) {
    display: flex;
    background-color: #8bd1ea;
    position: fixed;
    width: 100%;
    height: 100% !important;
    left: 0;
    top: 0;
    transition: 0.5s ease-in-out;
    transform: translateX(100%);
    flex-direction: column;
    padding-top: 20px;
    z-index: 1;
    overflow: scroll;
    &.open {
      transform: translateX(0%);
    }
    img {
      position: absolute;
      top: 20px;
      right: 20px;
      height: 25px;
    }
    ul {
      flex-direction: column;
      padding-left: 40px !important;
      align-items: flex-start !important;;
      li {
        font-size: 20px;
        font-family: "Bungee", cursive;
        width: fit-content;
        line-height: 25px;
        margin: 6px 0;
      }
    }
    button {
      width: fit-content;
      margin: 20px 0 0 50px;
    }
    .mobile-button{
      font-size:15px !important;
      line-height:25px;
      margin:5px 0 0 0 ;
      height: 42px;
    }
  }
`;
const ListItems = styled.div`
   position: absolute;
   display: none;
   width: 200px;
   background-color:#fed742;
   border: 3px solid black;
   z-index: 1;
   flex-direction: column;

   .list-item {
    padding-left: 10px;
    height: 40px;
    display: flex;
    align-items: center;
    &:hover {
      background-color: white;
    }
  }
`

const NavLinks = ({setIsFeedback}) => {
  
  const { t } = useTranslation();

  return (
      <ul style={{ display: "flex",padding:0,alignItems:'center' }}>
        {HeaderLinks.map((link, i) => (
          <Link key={i}>
            <a href={link.link ? link.link : null} target="_blank" rel="noreferrer">
             {t(link.name)}
            </a>
            {link.isList && (
              <ListItems className="list">
                {link.list.map((item, index) => (
                  <a href={item.link}  target="_blank" rel="noreferrer" className="list-item" key={index} >{t(item.name)}</a>
                ))}
              </ListItems>
            )}
          </Link>
        ))}
        <FeedBack onClick={()=>setIsFeedback(true)} className="mobile-button">
          {t('feedback')}
        </FeedBack>
      </ul>
  );
};
const SelectInput = (props) => {
  const { options, handleClick, value, isOptions, handleOption } = props;
  return (
    <SelectInputWrapper>
      <SelectContainer onClick={handleOption}>
        <p>{value}</p>
        <img src={Down} style={{ height: 10 }} alt="close" />
      </SelectContainer>
      {isOptions && (
        <OptionsContainer className={options.length > 4 && "scroll"}>
          {options.map((option, index) => {
            return (
              <div
                key={index}
                className={`option ${option.name === value && "active"}`}
                onClick={() => {
                  handleClick(option);
                }}
              >
                <span>{option.name}</span>
              </div>
            );
          })}
        </OptionsContainer>
      )}
    </SelectInputWrapper>
  );
};

function Navbar({ background, setShowModal,setIsFeedback }) {
  const [open, setOpen] = useState(false);
  const [languages, setLanguage] = useState("english");

  const { t } = useTranslation();

  const [isOptions, setIsOption] = useState(false);

  const handleOnSelect = (lang) => {
    setLanguage(lang.name);
    i18next.changeLanguage(lang.key);
    localStorage.setItem("lang", lang.key);
    setIsOption(false);
  };
  const handleOption = () => {
    setIsOption(!isOptions);
  };

  useEffect(() => {
    const langKey = localStorage.getItem("lang") || "en";
    i18next.changeLanguage(langKey);
    const filter = options.filter((lang) => lang.key === langKey);
    setLanguage(filter[0].name);
  }, [languages]);

  return (
    <Nav style={{ backgroundColor: background }}>
      <img
        src={Tamadoge_Logo}
        style={{ height: "50px" }}
        alt="logo"
        className="logo"
      />
      <LinkContainer><NavLinks setIsFeedback={setIsFeedback}/></LinkContainer>
      <BurgerMenuContainer
        className="burger-menu"
        onClick={() => setOpen(true)}
      >
        <img src={BurgerMenu} alt="menu" height="40px" />
      </BurgerMenuContainer>
      <ButtonContainer>
        <Button id="show_plans_popup" onClick={() => setShowModal(true)} className="buy-credit">
          {t("buy_credits")}
        </Button>
        <LinkButton href="https://tamadoge.io/nfts/" target="_blank" rel="noreferrer">{t("buy_nft")}</LinkButton>
        <LinkButton href="/" style={{ backgroundColor: "#FED742" }}>{t("play_game")}</LinkButton>
        <SelectInput
          options={options}
          handleClick={handleOnSelect}
          handleOption={handleOption}
          value={languages}
          isOptions={isOptions}
        />
      </ButtonContainer>
      <MobileViewContainer
        className={open && "open"}
        style={{ backgroundColor: background }}
      >
        <img src={BurgerCloseMenu} alt="menu" onClick={() => setOpen(false)} />
        <NavLinks setIsFeedback={setIsFeedback}/>
        <Button id="show_plans_popup" onClick={() => setShowModal(true)} style={{margin:'0 0 0 40px'}}>
          {t("buy_credits")}
        </Button>
        <Button style={{margin:'10px 0 0 40px'}}><a href="https://tamadoge.io/nfts/" target="_blank" rel="noreferrer" style={{color:'black',textDecoration:'none',fontSize:'13px'}}>{t("buy_nft")} </a></Button>
        <Button style={{ backgroundColor: "#FED742",margin:'10px 0 0 40px' }}><a href="/" style={{color:'black',fontSize:'13px',textDecoration:'none'}}>{t("play_game")}</a></Button>
        <div style={{ margin: "5px 0 150px 35px" }}>
          <SelectInput
            options={options}
            handleClick={handleOnSelect}
            handleOption={handleOption}
            value={languages}
            isOptions={isOptions}
          />
        </div>
      </MobileViewContainer>
    </Nav>
  );
}

export default Navbar;
